

exports.__esModule = true;

var _index = require('squid/index');

var _angular = require('angular');

var _index2 = require('xo-models/src/user/index');

var _index3 = require('xo-models/src/checkout/index');

var _index4 = require('xo-models/src/profilemanagement/index');

var _index5 = require('xo-models/src/frs/index');

var _logger = require('xo-beaver/dist/logger');

var _uiRouter = require('uiRouter');

var _index6 = require('xo-device-info/dist/index');

var _contentKeys = require('../../lib/contentKeys');

var _pxpExperimentConstants = require('../constants/pxpExperimentConstants');

var _pxpExperimentConstants2 = _interopRequireDefault(_pxpExperimentConstants);

require('./guest/directive.js');

require('./signup/directive.js');

require('xo-page-components/src/marketingOffers/directive.js');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

var _commonLib = require('../lib/commonLib');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _index.$Component.extend('xoOnboardOptions', {
    tag: 'xo-onboard-options',
    template: _template2['default'],

    props: {
        token: {
            type: 'var'
        },
        flags: {
            type: 'var'
        },
        mode: {
            type: 'var'
        },
        onboard: {
            type: 'var'
        },
        singlePagePaymentForm: {
            type: 'var'
        },
        validated: {
            type: 'var'
        },
        sepa: {
            type: 'var'
        },
        merchant: {
            type: 'var'
        },
        isUnbranded: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutInputData: _index2.$CheckoutInputDataModel.instance(this.token).retrieve(),
                payee: _index3.$CheckoutPayeeModel.instance(this.token).retrieve(),
                checkoutAppData: _index3.$CheckoutAppDataModel.instance(this.token).retrieve(),
                checkoutCart: _index3.$CheckoutCartModel.instance(this.token).retrieve(),
                flowEligibility: _index3.$FlowEligibilityModel.instance(this.token).retrieve()
            };
        },
        pomaExperiment: function pomaExperiment() {
            if (this.mode === 'guest') {
                return {
                    poma: (0, _index.$pxp)('XO_XOONBOARDING_POMA_GLOBAL', { 'ctx.COUNTRY': _index.$locale.country }, '(XO_XOONBOARDING_POMA_GLOBAL_)(.*)')
                };
            }
        },
        experiments: function experiments() {
            var experiment = 'xo_xoonboarding_dcc_';
            var pilotCountries = ['US', 'GB', 'CA', 'AU'];

            if (pilotCountries.indexOf(_index.$locale.country) > -1) {
                experiment += 'pilot';
            } else if (_index.$config.regions.EMEA.indexOf(_index.$locale.country) > -1) {
                experiment += 'emea';
            } else {
                experiment += 'row';
            }
            return {
                optionalSignupContent: (0, _index.$pxp)('xoon_optional_signup_content_change', { 'ctx.COUNTRY': _index.$locale.country }, '(xoon_optional_signup_content_change_)(.*)'),
                dccEligibility: (0, _index.$pxp)(experiment, { 'ctx.COUNTRY': _index.$locale.country }, experiment + '_treatment')
            };
        },
        freeReturnShippingExperiments: function freeReturnShippingExperiments(resolvers) {
            var _this = this;

            return resolvers.models.then(function (models) {
                var wpsOptional = models.checkoutAppData.is_wps_flow() && _this.mode === 'guest';
                var ecFlow = !models.checkoutAppData.is_wps_flow() && !models.checkoutInputData.isEbayTxn();
                var ecOptional = ecFlow && _this.mode === 'guest';
                var ecForced = ecFlow && _this.mode === 'signup';
                if (wpsOptional) {
                    return {
                        freeReturnShippingWpsOptionalExperiment: (0, _index.$pxp)('frs_wps_optional', { 'ctx.COUNTRY': _index.$locale.country }, '(frs_wps_optional_)(.*)')
                    };
                } else if (ecOptional) {
                    return {
                        freeReturnShippingEcOptionalExperiment: (0, _index.$pxp)('frs_ec_optional', { 'ctx.COUNTRY': _index.$locale.country }, '(frs_ec_optional_)(.*)')
                    };
                } else if (ecForced) {
                    return {
                        freeReturnShippingEcForcedExperiment: (0, _index.$pxp)('frs_ec_forced', { 'ctx.COUNTRY': _index.$locale.country }, '(frs_ec_forced_)(.*)')
                    };
                }
            });
        }
    },

    lifecycle: {
        enter: function enter() {
            this.locale = _index.$locale;
            this.splitScreenExp = _commonLib.SplitScreen.getSplitScreenExperience();
        },
        populate: function populate() {
            var _this2 = this;

            this.models.merchantPreference = _index4.$MerchantPreferenceModel.instance(this.models.payee.merchant.id);
            var isRP = this.models.checkoutCart.billing && this.models.checkoutCart.billing.type === 'RECURRING_PAYMENTS';
            var isWpsSubscription = this.models.checkoutAppData.is_wps_subscription_flow();
            var showBAContent = this.models.checkoutCart.isBilling() && !this.models.checkoutCart.isWalletTokenization();
            this.showBillingAgreementText = showBAContent && !isRP && !isWpsSubscription;
            this.showRpAgreementText = showBAContent && (isRP || isWpsSubscription);

            this.contentKeys = {};
            this.frsContentKeys = {};

            this.frsEcFlow = false;

            this.showMarketingOffers = function () {
                return !_this2.flags.allowChoice && !_this2.models.checkoutCart.isWalletTokenization() && !_this2.flags.freeReturnShippingOptInFlowApplicable && !_this2.flags.showSplitScreenExp;
            };

            var setUnbrandedContent = function setUnbrandedContent() {

                _this2.onboardTitleLine1 = _this2.isUnbranded ? 'common.getBenefitsUnBrandedLine1' : 'common.getBenefitsLine1';
                _this2.subTitle = _this2.isUnbranded ? 'common.createPayPalUnBrandedProp' : 'common.createPayPalProp';
                _this2.paypalSubTitle = _this2.isUnbranded ? 'common.createPayPalUnBrandedSubTitle' : 'common.createPayPalSubTitle';
                _this2.guestSignup1 = _this2.isUnbranded ? 'common.yesCreateUnBrandedAccount' : 'common.yesCreateAccount';
                _this2.guestSignup2 = _this2.isUnbranded ? 'common.nothanksUnBranded' : 'common.nothanks';
            };

            setUnbrandedContent();

            var contentOpts = {
                $config: _index.$config,
                cart: this.models.checkoutCart,
                appData: this.models.checkoutAppData
            };
            this.baContentKey = (0, _contentKeys.getBAContentKey)(contentOpts);
            this.rpContentKey = (0, _contentKeys.getRPContentKey)(contentOpts);
            this.wpsFlow = this.models.checkoutAppData.is_wps_flow();

            var setDCCEligibilityFlag = function setDCCEligibilityFlag() {

                if (_this2.mode === 'signup') {
                    return;
                }

                var experiment = _this2.experiments.dccEligibility;
                _this2.flags.dccCountryEligibility = experiment && experiment.treatment_name;
            };

            /**
             * show WPS interstitial page, if
             * 1. its optional sign up flow and
             * 2. not multistep flow and not DE
             * 3. merchant pref not have pdt or auto return and
             * 4. one touch throttle is not control
             * 5. wps interstitial throttle return treatment experiment
             **/
            var checkWPSInterstitialEligibility = function checkWPSInterstitialEligibility() {
                if (!_this2.wpsFlow) {
                    return;
                }
                if (_this2.mode === 'signup') {
                    _logger.$logger.info('wps_interstitial_not_eligible_force_signup');
                    return;
                }
                if (_this2.models.merchantPreference) {
                    if (_this2.models.merchantPreference.autoReturn()) {
                        _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_auto_return');
                        return;
                    }
                    if (_this2.models.merchantPreference.pdtEnabled()) {
                        _logger.$logger.info('wps_interstitial_not_eligible_merchant_prefer_pdt_enabled');
                        return;
                    }
                }

                if (_this2.splitScreenExp.isAccountMatched) {
                    _logger.$logger.info('wps_interstitial_not_eligible_splitscreen_account_matched');
                    return;
                }

                _logger.$logger.info('wps_interstitial_pxp_eligible_show_guestonly_and_wps_interstitial');
                _this2.flags.wpsInterstitialEligible = true;
                _this2.mode = 'guestonly';
            };

            var setEcPomaFlag = function setEcPomaFlag() {
                var pomaPXP = _this2.pomaExperiment.poma;
                if (pomaPXP && pomaPXP.treatment_name.indexOf('XO_XOONBOARDING_POMA_GLOBAL_TREATMENT') > -1) {
                    _logger.$logger.info('checkout_fpti', { is_poma: 1 });
                    _this2.flags.wpsInterstitialEligible = false;
                    _this2.flags.show_poma_ui = true;
                    _this2.POMAContentType = pomaPXP.treatment_name.indexOf('TREATMENT_A') > -1 ? 'TREATMENT_A' : 'TREATMENT_B';
                }
            };

            var setOptionalSignupPromotionContent = function setOptionalSignupPromotionContent() {
                if (_this2.mode !== 'guest') {
                    return;
                }

                var optionSignupContentPXP = _this2.experiments.optionalSignupContent;
                if (optionSignupContentPXP && optionSignupContentPXP.treatment_name) {
                    var treatmentContentKeys = _pxpExperimentConstants2['default'].test['xoon_optional_signup_content_change'][optionSignupContentPXP.treatment_name];

                    _this2.contentKeys = treatmentContentKeys ? treatmentContentKeys : {};
                }
            };

            var handleFrsContingency = function handleFrsContingency(message) {
                _logger.$logger.info('free_return_shipping_applicability_check_merchant_' + message);
                return false;
            };

            var handleFrsError = function handleFrsError(message, error) {
                _logger.$logger.info('free_return_shipping_applicability_check_merchant_' + message, error);
                return false;
            };

            var checkMerchantApplicabilityForFRS = function checkMerchantApplicabilityForFRS() {

                if (_index.$config.deploy.isLocal() || _index.$config.deploy.isStage()) {
                    // URL param used in Dev and Staging environment for testing purpose
                    var passedInVal = _index.$util.param('frsMerchantCheck');
                    if ('off'.indexOf(passedInVal) > -1) {
                        _logger.$logger.info('skipping_frs_merchant_applicability_check');
                        return _angular.$q.when(true);
                    }
                }

                var frsMerchantApplicabilityModel = new _index5.$FreeReturnShippingApplicabilityModel();

                var merchantApplicabilityRequest = {
                    context: 'MERCHANT',
                    merchantId: _this2.models.payee.get('merchant.id')
                };

                _logger.$logger.info('checkout_fpti', {
                    from: 'frs_flow_applicability',
                    to: 'prepare_frs_merchant_applicability'
                });

                // Once throttling of FRS experience is complete, we need to perform FRS applicability check in resolvers
                return frsMerchantApplicabilityModel.save({
                    data: merchantApplicabilityRequest,
                    success: function success(frsApplicabilityResponse) {
                        _logger.$logger.info('checkout_fpti', {
                            from: 'frs_flow_applicability',
                            to: 'process_frs_merchant_applicability',
                            eligibility_reason: frsApplicabilityResponse && frsApplicabilityResponse.applicable
                        });

                        return frsApplicabilityResponse && frsApplicabilityResponse.applicable;
                    },
                    contingencies: {
                        FRS_APPLICABILITY_ERROR: function FRS_APPLICABILITY_ERROR() {
                            return handleFrsContingency('FRS_APPLICABILITY_ERROR');
                        },
                        VALIDATION_ERROR: function VALIDATION_ERROR() {
                            return handleFrsContingency('VALIDATION_ERROR');
                        },
                        DEFAULT: function DEFAULT() {
                            return handleFrsContingency('UNHANDLED_CONTINGENCY');
                        }
                    },
                    validation: function validation(err) {
                        return handleFrsError('SERVICE_VALIDATION_ERROR', err);
                    },
                    error: function error(err) {
                        return handleFrsError('SERVICE_ERROR', err);
                    }
                });
            };

            var checkFrsFlowApplicability = function checkFrsFlowApplicability(frsPXP, flowType) {
                var treatmentName = frsPXP && frsPXP.treatment_name;
                var frsApplicableTreatments = _pxpExperimentConstants2['default'].test['frs_applicable_treatments'];
                var treatmentApplicable = frsApplicableTreatments[flowType] && frsApplicableTreatments[flowType].indexOf(treatmentName) > -1;

                _logger.$logger.info('checkout_fpti', {
                    from: 'frs_flow_applicability',
                    to: 'prepare_frs_optin_flow_applicability'
                });

                /**
                 * Invoke FRS check applicability API to determine eligible vs ineligible traffic for both test and control group
                 * When FRS treatment flow is applicable and FRS merchant applicability is true, FRS experience will be shown to user
                 * When FRS control flow is applicable, FRS experience will not be shown to user. Hence, return frs as not applicable
                 */
                return checkMerchantApplicabilityForFRS().then(function (frsApplicable) {

                    var flowApplicable = treatmentApplicable ? frsApplicable : false;

                    _logger.$logger.info('checkout_fpti', {
                        from: 'frs_flow_applicability',
                        to: 'process_frs_optin_flow_applicability',
                        eligibility_reason: flowApplicable
                    });

                    return flowApplicable;
                });
            };

            var getFrsExpAndFlowType = function getFrsExpAndFlowType(ecFlow) {
                var frsExp = void 0,
                    flowType = void 0;
                if (_this2.flags.wpsInterstitialEligible) {
                    frsExp = _this2.freeReturnShippingExperiments.freeReturnShippingWpsOptionalExperiment;
                    flowType = 'wps_optional';
                } else if (ecFlow && _this2.mode === 'guest') {
                    frsExp = _this2.freeReturnShippingExperiments.freeReturnShippingEcOptionalExperiment;
                    flowType = 'ec_optional';
                } else if (ecFlow && _this2.mode === 'signup' && !_this2.models.checkoutCart.isWalletTokenization()) {
                    frsExp = _this2.freeReturnShippingExperiments.freeReturnShippingEcForcedExperiment;
                    flowType = 'ec_forced';
                }

                return {
                    frsExp: frsExp,
                    flowType: flowType
                };
            };

            var setFreeReturnShippingEligibilityFlags = function setFreeReturnShippingEligibilityFlags() {
                if (_this2.flags.show_poma_ui) {
                    _logger.$logger.info('POMA_UI_enabled_free_return_shipping_feature_not_applicable');
                    return false;
                }

                var ecFlow = !_this2.models.checkoutInputData.isEbayTxn() && !_this2.wpsFlow;
                var frsFlowDetails = getFrsExpAndFlowType(ecFlow);

                if (frsFlowDetails.frsExp) {
                    checkFrsFlowApplicability(frsFlowDetails.frsExp, frsFlowDetails.flowType).then(function (frsFlowApplicable) {
                        if (frsFlowApplicable) {
                            _logger.$logger.info('free_return_shipping_optin_flow_applicable');

                            _this2.flags.freeReturnShippingOptInFlowApplicable = true;
                            /**
                             * Set whether FRS opt-in flow is Active (true) or Silent (false)
                             * Active flow - When opt-in involves explicit user action like activate button, checkbox.
                             * Silent flow - When opt-in doesn't have user action and performed automatically with account signup flow.
                             */
                            _this2.flags.freeReturnShippingOptInActiveFlow = false;

                            _this2.onboard.frs_optin_flow_applicable = true;
                            _this2.onboard.frs_optin_active_flow = false;

                            if (frsFlowDetails.flowType === 'wps_optional') {
                                _this2.flags.freeReturnShippingApplicableTreatment = frsFlowDetails.frsExp.treatment_name;
                            } else if (frsFlowDetails.flowType === 'ec_optional') {
                                _this2.frsEcFlow = true;
                                var treatmentContentKeys = _pxpExperimentConstants2['default'].test['frs_ec_optional'][frsFlowDetails.frsExp.treatment_name];
                                _this2.frsContentKeys = treatmentContentKeys ? treatmentContentKeys : {};
                            } else if (frsFlowDetails.flowType === 'ec_forced') {
                                _this2.frsEcFlow = true;
                                var _treatmentContentKeys = _pxpExperimentConstants2['default'].test['frs_ec_forced'][frsFlowDetails.frsExp.treatment_name];
                                _this2.frsContentKeys = _treatmentContentKeys ? _treatmentContentKeys : {};
                            }
                        }
                    });
                }
            };

            var setSplitScreenGuestOnlyEligibility = function setSplitScreenGuestOnlyEligibility() {
                if (_this2.mode === 'guest' && _this2.flags.isSplitScreenUserChoseGuest) {
                    _logger.$logger.info('splitscreen_user_chose_guest_on_ul_page_xoon_guest_only_eligible');
                    _this2.mode = 'guestonly';
                }
            };

            var setFlagsPostFlowEligibility = function setFlagsPostFlowEligibility() {
                var trackingModes = ['guest', 'guestonly'];
                _this2.flags.track_submit_transition = trackingModes.indexOf(_this2.mode) > -1 ? 'guest_xo' : 'signup';

                checkWPSInterstitialEligibility();
                setDCCEligibilityFlag();
                setOptionalSignupPromotionContent();
                setSplitScreenGuestOnlyEligibility();

                // POMA - Passwordless Onboarding of Member Accounts
                if (_this2.mode === 'guest' && _index.$locale.country === 'US' && !_index6.$DeviceInfo.isWebView()) {
                    if (!_this2.wpsFlow) {
                        setEcPomaFlag();
                    }
                }

                _this2.flags.mode = _this2.mode;
                _this2.flags.signupEnabled = _this2.mode !== 'guestonly';
                _this2.flags.allowChoice = _this2.mode !== 'signup';

                // Initialize showDisabledPasswordField to true.
                // NOTE: We use the if condition to check for undefined so the variable is assigned only once.
                // This method is called on every locale change, so we don't want it to be true on every change.
                // In future cases, signupSelected and guestSelected will set it accordingly.
                if (_this2.flags.showDisabledPasswordField === undefined) {
                    _this2.flags.showDisabledPasswordField = true;
                }

                // Set Free Return Shipping Opt-in eligibility flags
                setFreeReturnShippingEligibilityFlags();
            };

            setFlagsPostFlowEligibility();
        }
    },
    actions: {
        setBuyerModeFlags: function setBuyerModeFlags(newValue) {
            switch (newValue) {
                case 'guest':
                case 'guestonly':
                    // show disabled password field for variant2
                    this.flags.showDisabledPasswordField = true;
                    _logger.$logger.info('Guest_Signup_No');
                    this.flags.mode = newValue;
                    this.flags.track_submit_transition = 'guest_xo';
                    break;
                case 'signup':
                    // hide disabled password field
                    this.flags.showDisabledPasswordField = false;
                    this.flags.ignoreValidationTheFirstTime = true;
                    _logger.$logger.info('Guest_Signup_Yes');
                    this.flags.mode = newValue;
                    this.flags.track_submit_transition = 'guest_optional_signup';
                    break;
                default:
                // Do Nothing
            }
            this.accountCreationSectionErrorMessage = '';
            $('.signupFieldsContainer .radioButton').removeClass('warning');
            _uiRouter.$state.current.trackingData.pageQualifier = newValue;
            return true;
        },
        triggerTimerForSignupClicked: function triggerTimerForSignupClicked() {
            if (window.performance) {
                _logger.$logger.info('sign up option clicked, start timer...', window.performance.now());
                this.$emit('signupClickedTimerStarted', window.performance.now());
            }
        },
        onCheckedSavedMyInfo: function onCheckedSavedMyInfo($event) {
            if ($event.target.checked) {
                // populating the legal terms key to send the TCPA details to OAS later during onboarding
                this.flags.tcpa_identifier = 'poma.legalTerms';
                this.flags.poma_flow = true;
                this.flags.track_submit_transition = 'poma_signup';
                $('.pomaFieldsContainer').addClass('focusBorder');
                $('.pomaFieldsContainer').addClass('active');
                _logger.$logger.info('POMA_CHECKBOX_SELECTED');
                if ($('#pomaSubmit').offset()) {
                    window.scrollTo(0, this.$element.parent().find('#pomaSubmit').offset().top);
                }
            } else {
                this.flags.tcpa_identifier = undefined;
                this.flags.poma_flow = false;
                this.flags.track_submit_transition = 'guest_xo';
                $('.pomaFieldsContainer').removeClass('focusBorder');
                $('.pomaFieldsContainer').removeClass('active');
                _logger.$logger.info('POMA_CHECKBOX_DESELECTED');
            }
        }
    }
});


_index.$Component;

_index.$locale;

_index.$pxp;

_index.$config;

_index.$util;

_angular.$q;

_index2.$CheckoutInputDataModel;

_index3.$CheckoutAppDataModel;

_index3.$CheckoutPayeeModel;

_index3.$CheckoutCartModel;

_index3.$FlowEligibilityModel;

_index4.$MerchantPreferenceModel;

_index5.$FreeReturnShippingApplicabilityModel;

_logger.$logger;

_uiRouter.$state;

_index6.$DeviceInfo;

_contentKeys.getBAContentKey;

_contentKeys.getRPContentKey;

_commonLib.SplitScreen;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-guest-components/src/guest/onboardOptions/directive.js
// module id = ./components/xo-guest-components/src/guest/onboardOptions/directive.js
// module chunks = 1